// extracted by mini-css-extract-plugin
export var addButton = "_dc-4";
export var contentBlockImage = "_dc-i";
export var contentBlockWidgetPreview = "_dc-g";
export var fulfillmentCutoffWidgetPreview = "_dc-9";
export var imageBackdrop = "_dc-6";
export var imageIcon = "_dc-8";
export var lowProfileImageContainer = "_dc-b";
export var lowProfileImageIcon = "_dc-f";
export var lowProfileImageIconContainer = "_dc-e";
export var lowProfileImagePlaceholder = "_dc-d";
export var lowProfileProductImage = "_dc-c";
export var lowProfileProductUpsellWidgetPreview = "_dc-a";
export var productCard = "_dc-5";
export var productImage = "_dc-7";
export var productReviewsWidgetPreview = "_dc-h";
export var progressBar = "_dc-1";
export var progressBarFill = "_dc-2";
export var progressBarTrack = "_dc-3";
export var shippingOptionWidgetPreview = "_dc-j";
export var shippingUpsellProgressBar = "_dc-k";
export var thresholdUpsellWidgetPreview = "_dc-0";